export default __webpack_public_path__ + "static/media/logo-color-1.d16698ec.png";